<script setup>
import {envs} from "@/main/envs";
import FallbackComponent from "@/themes/dark/views/DarkFaq.vue";
import {defineAsyncComponent} from "vue";

const component_name = 'Partners';

const ThemeComponent = defineAsyncComponent({
  // 动态加载主题组件
  loader: () => import(`@/themes/${envs.theme}/views/${envs.theme[0].toUpperCase() + envs.theme.slice(1)}${component_name}.vue`)
      .catch(() => FallbackComponent), // 如果加载失败，使用默认组件
  // 可选：加载提示组件
  // loadingComponent: LoadingComponent,
  // 超时时间，避免长时间挂起
  timeout: 3000,
});
</script>

<template>
  <component :is="ThemeComponent" />
</template>
